import { useVideoConfig, type VolumeProp } from "remotion";
import type { AudioLayerProps, VideoLayerProps } from "../types";
import { remotionMediaVolume } from "../media-volume";

/**
 * Props the renderer injects at paint time. Not persisted in composition
 * JSON: `from` / `duration` already store the timeline slot. Injected
 * `durationInFrames` is the visible clip length; inside the trim Sequence,
 * `useVideoConfig()` reports `layer.duration + trimStart` instead.
 */
type InjectedLayerTiming = {
  durationInFrames?: number;
};

export type AudioLayerRenderProps = AudioLayerProps & InjectedLayerTiming;

export type VideoLayerRenderProps = VideoLayerProps & InjectedLayerTiming;

/** Remotion `volume` prop for audio or video diegetic, with optional fades. */
export function useRemotionLayerVolume({
  volume,
  fadeInSeconds,
  fadeOutSeconds,
  durationInFrames,
}: {
  volume?: unknown;
  fadeInSeconds?: unknown;
  fadeOutSeconds?: unknown;
  durationInFrames?: number;
}): VolumeProp {
  const { fps } = useVideoConfig();
  return remotionMediaVolume({
    durationInFrames,
    fps,
    volume,
    fadeInSeconds,
    fadeOutSeconds,
  });
}
